import React, { useEffect, useState } from "react";
import apiClient from "../../lib/api";
import { useI18n } from "../../i18n";
import { Search } from "lucide-react";

const AdminCustomers = () => {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => { apiClient.get("/admin/customers").then((r) => setItems(r.data)); }, []);
  useEffect(() => {
    if (!selected) { setDetail(null); return; }
    apiClient.get(`/admin/customers/${selected}`).then((r) => setDetail(r.data));
  }, [selected]);

  const filtered = items.filter((c) => !q || c.email.toLowerCase().includes(q.toLowerCase()) || c.name?.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="admin-customers-page">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-light">{lang === "nl" ? "Klanten" : "Customers"}</h1>
        <div className="flex items-center bg-white border border-black/15 px-3 py-2">
          <Search className="w-4 h-4 text-ink-muted" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Email or name" className="bg-transparent outline-none px-2 text-sm w-56" data-testid="admin-customers-search" />
        </div>
      </div>

      <div className="grid md:grid-cols-12 gap-6">
        <div className="md:col-span-7 border border-black/10 bg-white divide-y divide-black/5 max-h-[70vh] overflow-y-auto">
          {filtered.map((c) => (
            <button key={c.user_id} onClick={() => setSelected(c.user_id)} className={`w-full text-left p-4 grid grid-cols-3 gap-3 hover:bg-secondary-warm ${selected === c.user_id ? "bg-secondary-warm" : ""}`} data-testid={`customer-row-${c.email}`}>
              <div className="font-display">{c.name}</div>
              <div className="text-sm">{c.email}</div>
              <div className="text-xs text-ink-muted text-right">{c.created_at?.slice(0, 10)}</div>
            </button>
          ))}
        </div>
        <div className="md:col-span-5">
          {!detail && <div className="border border-black/10 bg-white p-6 text-ink-muted text-sm">{lang === "nl" ? "Selecteer een klant" : "Select a customer"}</div>}
          {detail && (
            <div className="border border-black/10 bg-white p-6 space-y-4" data-testid="customer-detail">
              <div>
                <div className="font-display text-2xl">{detail.name}</div>
                <div className="text-sm text-ink-muted">{detail.email}</div>
                <div className="text-xs font-label mt-2">Role: {detail.role}</div>
              </div>
              <div className="grid grid-cols-2 gap-3 text-sm border-y border-black/5 py-4">
                <div><div className="font-label text-ink-muted">Orders</div><div className="font-display text-xl">{detail.orders_count}</div></div>
                <div><div className="font-label text-ink-muted">LTV</div><div className="font-display text-xl">€{detail.lifetime_value.toFixed(2)}</div></div>
              </div>
              <div>
                <div className="font-label text-ink-muted mb-2">Recent orders</div>
                {(detail.orders || []).slice(0, 5).map((o) => (
                  <div key={o.order_id} className="flex justify-between text-sm py-1.5 border-b border-black/5 last:border-0">
                    <span>{o.order_id}</span>
                    <span>€{o.grand_total.toFixed(2)}</span>
                    <span className="text-ink-muted text-xs">{o.status}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminCustomers;
